import "./runtimeEnvironment-BB2sO-19.mjs";
import { deprecated, deprecatedObjectProperty, deprecatedProperty } from "./deprecated-BqlFbLHj.mjs";

export { deprecated, deprecatedObjectProperty, deprecatedProperty };